import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { REPORT_PRESET } from '../../pickers';
import { LANDING_PAGES_REPORT_ID } from './landingPagesReportId';

// columns used by the 'All' column view
export const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.TITLE.field,
    FIELDS.LANDING_PAGES_STATUS.field,
    FIELDS.LANDING_PAGES_SLUG.field,
    FIELDS.LANDING_PAGES_TABOOLA_PIXEL.field,
    FIELDS.LANDING_PAGES_CREATE_TIME.field,
    FIELDS.LANDING_PAGES_UPDATE_TIME.field,
    FIELDS.LANDING_PAGES_PUBLISH_TIME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(LANDING_PAGES_REPORT_ID, field));

export const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.ID.field,
        FIELDS.TITLE.field,
        FIELDS.LANDING_PAGES_STATUS.field,
        FIELDS.LANDING_PAGES_SLUG.field,
        FIELDS.LANDING_PAGES_TABOOLA_PIXEL.field,
        FIELDS.LANDING_PAGES_CREATE_TIME.field,
        FIELDS.LANDING_PAGES_UPDATE_TIME.field,
        FIELDS.LANDING_PAGES_PUBLISH_TIME.field,
        FIELDS.CREATED_BY.field,
        FIELDS.UPDATED_BY.field,
        FIELDS.PUBLISHED_BY.field,
    ].map(field => generateColumnId(LANDING_PAGES_REPORT_ID, field)),
};
